var e = {
	bar: {
		label: "Property search",
		filtersLabel: "Property search filters",
		where: "Where",
		when: "When",
		who: "Who",
		anywhere: "Anywhere",
		anyWeek: "Any week",
		searchDestinations: "Search destinations",
		addLocation: "Add location",
		addDates: "Add dates",
		addGuests: "Add guests",
		search: "Search properties"
	},
	guests: {
		title: "Guests",
		adults: "Adults",
		adultsAge: "Ages 13 or above",
		children: "Children",
		childrenAge: "Ages 2–12",
		infants: "Infants",
		infantsAge: "Under 2",
		decrease: "Decrease {{label}}",
		increase: "Increase {{label}}",
		guestCount_one: "{{count}} guest",
		guestCount_other: "{{count}} guests",
		infantCount_one: "{{count}} infant",
		infantCount_other: "{{count}} infants"
	},
	placeSearch: {
		placeholder: "Search destinations",
		noResults: "No results found",
		startTyping: "Start typing to search",
		recentTitle: "Recent searches",
		popularTitle: "Popular destinations",
		nearMe: "Near me",
		nearMeHint: "Use my current location",
		nearMeLocating: "Getting your location…",
		nearMeDenied: "Location access is off. Turn it on in your settings to search near you.",
		nearMeUnavailable: "We couldn't get your location. Try searching for a destination instead.",
		nearMeTimeout: "Getting your location took too long. Try again.",
		nearMeSettingsTitle: "Location access is off",
		nearMeSettingsBody: "Allow location for Maat in Settings to search near you.",
		nearMeOpenSettings: "Open settings",
		placesSection: "Places"
	},
	home: {
		empty: "No properties found nearby.",
		welcomeBack: {
			heading: "Welcome back",
			dismiss: "Dismiss recent search for {{place}}",
			continueSearching: {
				kicker: "Continue searching",
				title_unit: "Homes in {{place}}",
				title_experience: "Experiences in {{place}}",
				title_service: "Services in {{place}}",
				anyDates: "Any dates"
			},
			completeReservation: {
				kicker: "Complete your reservation",
				expiresIn: "{{time}} left",
				heldForYou: "Your dates are still held for you",
				stillAvailable: "Your dates are still available"
			}
		},
		recentlyViewed: { heading: "Recently viewed" }
	},
	map: {
		label: "Map search",
		mapArea: "Homes in map area",
		backToHome: "Back to home",
		truncated: "Showing {{shown}} of {{total}} stays — zoom in to see the rest.",
		empty: "No properties in this area. Try zooming out or panning the map.",
		zoomIn: "Zoom in to see more stays",
		loading: "Searching…",
		close: "Close",
		collapseList: "Collapse the results list",
		closePreview: "Dismiss the selected stay",
		resultCount_one: "{{count}} stay",
		resultCount_other: "{{count}} stays",
		summaryLine: "{{dates}} · {{guests}}"
	},
	overlay: {
		ariaLabel: "Global search",
		placeholder: "Search bookings, listings, chats…"
	},
	searchBar: { ariaLabel: "Search" },
	results: {
		sections: {
			booking: "Bookings",
			listing: "Listings",
			conversation: "Conversations",
			recentlyVisited: "Recently visited",
			user: "Users",
			workspace: "Workspaces"
		},
		noResults: "No results for “{{query}}”",
		startTyping: "Start typing to search",
		seeAll: "See all",
		propertiesTitle: "Stays matching your search",
		perNight: "{{price}} night",
		searchDestination: "Search {{place}}",
		searchDestinationHint: "See stays on the map"
	},
	recentlyVisited: { empty: "Nothing visited yet — places you open will show up here." },
	routeSearch: { goTo: "Go to" },
	bottomBar: {
		home: "Home",
		close: "Close"
	},
	conversationType: {
		INBOX: "Inbox",
		DIRECT: "Direct message"
	},
	inventoryKind: {
		service: "Service",
		experience: "Experience"
	},
	workspaceType: {
		INDIVIDUAL: "Individual",
		LEGAL_ENTITY: "Legal entity"
	},
	workspace: { suspended: "Suspended" },
	filters: {
		title: "Filters",
		description: "Refine your property search",
		clearAll: "Clear all",
		showResults: "Show results",
		guests: {
			title: "Guests",
			minLabel: "Guests (min)"
		},
		rooms: {
			title: "Rooms & Beds",
			bedroomsMin: "Bedrooms (min)",
			bathroomsMin: "Bathrooms (min)"
		},
		type: {
			title: "Property Type",
			any: "Any type"
		},
		price: {
			title: "Price per night",
			caption: "Nightly rate, before fees and taxes",
			minimum: "Minimum",
			maximum: "Maximum",
			currencyNote: "Prices shown in {{currency}}",
			currencyNoteOpen: "Prices shown in {{currency}}. The top of the range includes anything dearer.",
			bucketTooltip_one: "{{from}} – {{to}} · {{count}} stay",
			bucketTooltip_other: "{{from}} – {{to}} · {{count}} stays",
			bucketTooltipOpen_one: "{{from}} and up · {{count}} stay",
			bucketTooltipOpen_other: "{{from}} and up · {{count}} stays",
			any: "Any"
		},
		amenities: {
			title: "Amenities",
			selected: "{{count}} selected",
			searchPlaceholder: "Search amenities",
			noMatch: "No amenities match “{{query}}”."
		},
		amenityCategories: {
			amenities: "Amenities",
			features: "Features & views",
			essentials: "Essentials",
			safety: "Family & safety"
		}
	},
	suggestions: {
		budget: {
			title: "Under {{price}} per night",
			fallbackTitle: "Good value stays",
			subtitle: "Great places in this area for less"
		},
		similarDates: {
			title: "Available for similar dates",
			subtitle_one: "The same 1-night stay, a few days either way",
			subtitle_other: "The same {{count}}-night stay, a few days either way"
		}
	},
	assistant: {
		composerPlaceholder: "Where to? Or describe your trip",
		disclaimer: "Maat AI can make mistakes. Check the listing before you book.",
		clearSearch: "Clear search",
		askMaat: "Ask Maat",
		askAbout: "Ask Maat about “{{query}}”",
		askAboutThis: "Ask about this",
		askingAbout: "Asking about",
		greeting: "Describe the stay you want — the area, who's coming, your budget — and I'll find it.",
		prompts: {
			beachfront: "Beachfront place in El Gouna for 6 under $150",
			quiet: "Quiet studio with fast wifi and a workspace",
			family: "Family apartment with a pool, 3 bedrooms",
			walkable: "Somewhere walkable for a week in August"
		},
		listing: {
			greeting: "Ask me anything about this place — your dates, the house rules, what's nearby.",
			composerPlaceholder: "Ask about this place",
			prompts: {
				availability: "Is it available for my dates?",
				pets: "Does it allow pets?",
				cancellation: "What's the cancellation policy?",
				checkIn: "What time is check-in and check-out?"
			}
		},
		booking: {
			greeting: "Ask me anything about this trip — your dates, check-in, what happens if you cancel.",
			composerPlaceholder: "Ask about this trip",
			prompts: {
				checkIn: "What time can I check in?",
				cancel: "What do I get back if I cancel?",
				paid: "How much did I pay?",
				status: "Is my booking confirmed?"
			}
		},
		newSearch: "New search",
		continueTitle: "Continue your last search",
		host: {
			greeting: "Ask about your bookings, earnings or reviews — I'll pull the numbers.",
			newConversation: "New conversation",
			continueTitle: "Continue your last conversation",
			composerPlaceholder: "Ask about your bookings, earnings or reviews",
			prompts: {
				pending: "Which booking requests are still waiting on me?",
				earnings: "How did last month go?",
				trends: "Show my revenue trend for the last 6 months",
				reviews: "What are guests saying in my recent reviews?"
			}
		},
		intentTitle: "What I understood",
		seeAllStays: "See all stays",
		chips: {
			bedrooms_one: "{{count}}+ bedroom",
			bedrooms_other: "{{count}}+ bedrooms",
			bathrooms_one: "{{count}}+ bathroom",
			bathrooms_other: "{{count}}+ bathrooms",
			upTo: "Up to {{price}}",
			from: "From {{price}}"
		}
	},
	slotCard: {
		imageAlt: "{{title}}",
		instant: "Instant book",
		kind: {
			experience: "Experience",
			service: "Service"
		}
	},
	entry: {
		close: "Close search",
		search: "Search",
		whereTitle: "Where?",
		askMaatTitle: "Or describe your trip"
	},
	kindTabs: {
		stays: "Stays",
		experiences: "Experiences",
		services: "Services"
	},
	discover: {
		experiences: {
			title: "Experiences",
			subtitle: "Things to do, run by people who live there.",
			happeningToday: "Happening today",
			happeningTodayIn: "Happening today in {{city}}",
			empty: {
				title: "No experiences here yet",
				titleCity: "No experiences in {{city}} yet",
				body: "Hosts are still adding experiences here. Try another destination, or check back soon."
			},
			emptyCategory: {
				title: "No {{category}} in {{city}} yet",
				titleNoCity: "No {{category}} here yet",
				body: "Try another category, or pick a different destination."
			}
		},
		services: {
			title: "Services",
			subtitle: "People and equipment you can book for your stay.",
			empty: {
				title: "No services here yet",
				titleCity: "No services in {{city}} yet",
				body: "Providers are still joining here. Try another destination, or check back soon."
			},
			emptyCategory: {
				title: "No {{category}} in {{city}} yet",
				titleNoCity: "No {{category}} here yet",
				body: "Try another service type, or pick a different destination."
			}
		},
		categories: {
			all: "All",
			available_one: "{{count}} available",
			available_other: "{{count}} available"
		},
		where: {
			label: "Where",
			anywhere: "Anywhere",
			placeholder: "Search a city or area",
			clear: "Clear destination"
		},
		loadError: {
			title: "We couldn't load this",
			body: "Something went wrong on our side. Try again in a moment.",
			retry: "Try again"
		}
	}
};
//#endregion
export { e as default };
